import { inject, InjectionToken } from '@angular/core';
import { WorkflowStorageDatabase } from './workflow-storage.database';
import type { WorkflowStorageStore } from './workflow-storage.types';

export const WORKFLOW_STORAGE_STORE = new InjectionToken<WorkflowStorageStore>(
  'WORKFLOW_STORAGE_STORE',
  {
    factory: () => inject(WorkflowStorageDatabase),
    providedIn: 'root',
  },
);
